/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import AvatarUser from "../../../static/icon/AvatarUser.svg";
import { Image } from "react-bootstrap";
import { Button } from "antd";
import { useTranslation } from "react-i18next";
import MoreDataBtn from "../MoreDataBtnIMG";

interface WaterfallGalleryProps {
	images: any; // base64 数组
	initialColumnCount?: number; // 列数
	item: any;
}

const WaterfallGallery: React.FC<WaterfallGalleryProps> = ({
	images,
	initialColumnCount = 3,
	item,
}) => {
	const { t, i18n } = useTranslation();

	const [columnCount, setColumnCount] = useState(initialColumnCount);
	const [columns, setColumns] = useState<string[][]>(
		Array.from({ length: initialColumnCount }, () => [])
	);
	const columnHeightsRef = useRef<number[]>(Array(initialColumnCount).fill(0)); // 使用 ref 存储列高度
	const [expanded, setExpanded] = useState(false);

	const handleToggleExpand = () => {
		setColumnCount(expanded ? initialColumnCount! : 6); // 切换列数
		setExpanded(!expanded);
	};

	const resetColumns = (newColumnCount: number) => {
		setColumns(Array.from({ length: newColumnCount }, () => []));
		columnHeightsRef.current = Array(newColumnCount).fill(0);
	};

	useEffect(() => {
		resetColumns(columnCount);
	}, [columnCount, images]);

	const handleImageLoad = (image: string, height: number) => {
		// 找到当前高度最小的列
		const shortestColumnIndex = columnHeightsRef.current.indexOf(
			Math.min(...columnHeightsRef.current)
		);

		// console.log(columnHeightsRef.current, shortestColumnIndex);

		// 将图片添加到该列
		setColumns((prevColumns) => {
			const newColumns = [...prevColumns];
			newColumns[shortestColumnIndex] = [
				...newColumns[shortestColumnIndex],
				image,
			];
			return newColumns;
		});

		// 更新列的高度
		columnHeightsRef.current[shortestColumnIndex] += height;
	};

	return (
		<div className="waterfall">
			<div className={"chatList-item"} key={"tmp"}>
				<div className="chatList-item-img">
					<Image src={AvatarUser} />
				</div>
				<div
					className={`chatList-item-user-waterfall ${
						expanded ? "expanded" : ""
					}`}
				>
					<div className="chatList-item-user-name">
						{i18n.language == "en" ? "DOCTA" : "第五维度"}
					</div>
					<div className="chatList-item-box-wrapper">
						<div className="chatList-item-dialog-box-ai">
							<div
								className={`waterfall-gallery ${expanded ? "expanded" : ""}`}
							>
								{Array.from({ length: columnCount }).map((_, colIdx) => (
									<div key={colIdx} className="waterfall-column">
										{images
											?.filter(
												(_: any, imgIdx: any) => imgIdx % columnCount === colIdx
											)
											?.map((base64Image: any, imgIdx: any) => (
												<img
													key={imgIdx}
													src={`${base64Image}`}
													alt={`Image ${imgIdx}`}
													onLoad={(e) =>
														handleImageLoad(
															base64Image,
															(e.target as HTMLImageElement).height
														)
													}
												/>
											))}
									</div>
								))}
								{/* {!expanded && (
									<div className="view-more-overlay">
										<Button onClick={handleViewMore}>View More</Button>
									</div>
								)} */}
								<div className="view-more-overlay"></div>
							</div>
							<div className="view-more-btn">
								<Button onClick={handleToggleExpand} type="text" shape="round">
									{expanded ? "View Less" : "View More"}
								</Button>
							</div>
							<MoreDataBtn data={item.data} imageUrl={images?.[0]} />
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default WaterfallGallery;
